export type TYPE_FILTER_TYPE = 'ALL' | 'PROGRAMME' | 'INSTRUMENT' | 'OPERATION';
